<template>
  <footer class="footer">
    <b-container>
      <b-row>
        <b-col xl="10" offset-xl="1" class="mb-4 h4">
          <b-row>
            <b-col v-for="social in socials" :key="social.name">
              <a :href="social.link" :title="`CoinTrackr ${social.name} Page`" target="_blank">
                <i class="fa fa-fw" :class="social.iconClass"></i>
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>

    <p v-if="donateList_filtered.length > 0">
      <b>{{ $t("footer.donating") }}</b>
    </p>
    <p
      v-for="donateItem in donateList_filtered"
      v-bind:key="donateItem.currency"
    >
      {{ donateItem.currency }}:
      <a :href="donateItem.link" target="_blank">{{ donateItem.value }}</a>
    </p>

    <p class="mt-3">{{ $t("footer.right_reserve") }}</p>
    <p>
      {{ $t("footer.version") }} {{ version }} |
      <router-link to="/changelog">{{ $t("footer.changelog") }}</router-link>
    </p>
  </footer>
</template>

<script>
import options from "@/options";

export default {
  created() {
    const socials = options.socials.filter((v) => v.showFooter);
    socials.sort((a, b) => a.orderFooter - b.orderFooter);
    this.socials = socials;
    this.version = options.version;
    this.donateList_filtered = options.donateList.filter((v) => v.active);
  },
};
</script>
